import { render, staticRenderFns } from "./ModalChats.vue?vue&type=template&id=d2210aca&scoped=true&"
import script from "./ModalChats.vue?vue&type=script&lang=js&"
export * from "./ModalChats.vue?vue&type=script&lang=js&"
import style0 from "./ModalChats.vue?vue&type=style&index=0&id=d2210aca&prod&lang=scss&scoped=true&"
import style1 from "./ModalChats.vue?vue&type=style&index=1&id=d2210aca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2210aca",
  null
  
)

export default component.exports